/**
 * P-26 GlobalHeader — SPハンバーガードロワー／メガメニューの開閉
 * @see docs/tds-components.md #19 P-26 GlobalHeader
 */
(function () {
  function getDrawer(header) {
    return header.querySelector('[data-header-drawer]');
  }

  function getToggle(header) {
    return header.querySelector('[data-drawer-toggle]');
  }

  function lockScroll() {
    document.documentElement.style.overflow = 'hidden';
  }

  function unlockScroll() {
    document.documentElement.style.overflow = '';
  }

  function isDrawerOpen(header) {
    return header.getAttribute('data-drawer-open') === 'true';
  }

  function openDrawer(header) {
    var drawer = getDrawer(header);
    var toggle = getToggle(header);
    if (!drawer || !toggle || isDrawerOpen(header)) return;

    drawer.removeAttribute('hidden');
    toggle.setAttribute('aria-expanded', 'true');
    header.setAttribute('data-drawer-open', 'true');
    lockScroll();

    var closeBtn = drawer.querySelector('[data-drawer-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer(header) {
    var drawer = getDrawer(header);
    var toggle = getToggle(header);
    if (!drawer || !toggle || !isDrawerOpen(header)) return;

    drawer.setAttribute('hidden', '');
    toggle.setAttribute('aria-expanded', 'false');
    header.removeAttribute('data-drawer-open');
    closeDrawerAccordion(header);
    unlockScroll();
    toggle.focus();
  }

  // ── メガメニュー ─────────────────────────────

  function getMegaPanel(header, axis) {
    return header.querySelector('[data-mega-panel="' + axis + '"]');
  }

  function getOpenMegaAxis(header) {
    return header.getAttribute('data-mega-open');
  }

  function getAxisButtons(header, axis) {
    var all = header.querySelectorAll('[data-mega-target="' + axis + '"]');
    return Array.prototype.filter.call(all, function (btn) {
      return !btn.closest('[data-header-drawer]');
    });
  }

  function setAxisExpanded(header, axis, expanded) {
    getAxisButtons(header, axis).forEach(function (btn) {
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function closeMega(header) {
    var axis = getOpenMegaAxis(header);
    if (!axis) return;

    var panel = getMegaPanel(header, axis);
    if (panel) panel.setAttribute('hidden', '');
    setAxisExpanded(header, axis, false);
    header.removeAttribute('data-mega-open');
  }

  function openMega(header, axis) {
    var panel = getMegaPanel(header, axis);
    if (!panel) return;

    // 排他制御: 別の軸が開いていれば先に閉じる
    var current = getOpenMegaAxis(header);
    if (current && current !== axis) closeMega(header);

    panel.removeAttribute('hidden');
    setAxisExpanded(header, axis, true);
    header.setAttribute('data-mega-open', axis);
  }

  function toggleMega(header, axis) {
    if (getOpenMegaAxis(header) === axis) {
      closeMega(header);
    } else {
      openMega(header, axis);
    }
  }

  // ── ドロワー内アコーディオン（ヘッダー側メガパネルとは別グループで排他制御） ──

  function getDrawerPanelBody(header, axis) {
    var drawer = getDrawer(header);
    return drawer && drawer.querySelector('[data-drawer-panel="' + axis + '"]');
  }

  function getOpenDrawerPanelAxis(header) {
    return header.getAttribute('data-drawer-panel-open');
  }

  function getDrawerPanelButtons(header, axis) {
    var drawer = getDrawer(header);
    return drawer ? drawer.querySelectorAll('[data-mega-target="' + axis + '"]') : [];
  }

  function setDrawerPanelExpanded(header, axis, expanded) {
    getDrawerPanelButtons(header, axis).forEach(function (btn) {
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var caret = btn.querySelector('.tds-header__axis-caret');
      if (caret) caret.textContent = expanded ? '▲' : '▼';
    });
  }

  function closeDrawerAccordion(header) {
    var axis = getOpenDrawerPanelAxis(header);
    if (!axis) return;

    var panel = getDrawerPanelBody(header, axis);
    if (panel) panel.setAttribute('hidden', '');
    setDrawerPanelExpanded(header, axis, false);
    header.removeAttribute('data-drawer-panel-open');
  }

  function openDrawerAccordion(header, axis) {
    var panel = getDrawerPanelBody(header, axis);
    if (!panel) return;

    // 排他制御: ドロワー内で別項目が開いていれば先に閉じる（ヘッダー側メガパネルとは別グループ）
    var current = getOpenDrawerPanelAxis(header);
    if (current && current !== axis) closeDrawerAccordion(header);

    panel.removeAttribute('hidden');
    setDrawerPanelExpanded(header, axis, true);
    header.setAttribute('data-drawer-panel-open', axis);
  }

  function toggleDrawerAccordion(header, axis) {
    if (getOpenDrawerPanelAxis(header) === axis) {
      closeDrawerAccordion(header);
    } else {
      openDrawerAccordion(header, axis);
    }
  }

  function bindMegaTriggers(header) {
    header.querySelectorAll('[data-mega-target]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var axis = btn.getAttribute('data-mega-target');
        if (btn.closest('[data-header-drawer]')) {
          // ドロワー内で完結するアコーディオン開閉（ヘッダー側メガパネルとは独立）
          toggleDrawerAccordion(header, axis);
          return;
        }
        toggleMega(header, axis);
      });
    });

    header.querySelectorAll('[data-mega-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeMega(header);
      });
    });
  }

  // ── 共通バインド ─────────────────────────────

  function bindHeader(header) {
    if (!header || header.getAttribute('data-drawer-bound') === 'true') return;

    var toggle = getToggle(header);
    var drawer = getDrawer(header);
    if (!toggle || !drawer) return;

    toggle.addEventListener('click', function () {
      if (isDrawerOpen(header)) {
        closeDrawer(header);
      } else {
        closeMega(header);
        openDrawer(header);
      }
    });

    var closeBtn = drawer.querySelector('[data-drawer-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeDrawer(header);
      });
    }

    // オーバーレイ背景クリックで閉じる（.tds-header__drawer 自身＝子要素以外をクリックしたときのみ）
    drawer.addEventListener('click', function (event) {
      if (event.target === drawer) {
        closeDrawer(header);
      }
    });

    bindMegaTriggers(header);

    // メガパネルの外側クリックで閉じる（軸ボタン自身のクリックは各ボタンのリスナーで処理済みのため除外）
    document.addEventListener('click', function (event) {
      var axis = getOpenMegaAxis(header);
      if (!axis) return;
      var panel = getMegaPanel(header, axis);
      if (!panel) return;
      if (panel.contains(event.target) || event.target.closest('[data-mega-target]')) return;
      closeMega(header);
    });

    header.setAttribute('data-drawer-bound', 'true');
  }

  function unbindHeader(header) {
    if (!header) return;
    closeDrawer(header);
    closeMega(header);
    closeDrawerAccordion(header);
    header.removeAttribute('data-drawer-bound');
  }

  function bootAll() {
    document.querySelectorAll('[data-tds-header]').forEach(bindHeader);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    var openDrawerHeader = document.querySelector('[data-tds-header][data-drawer-open="true"]');
    if (openDrawerHeader) closeDrawer(openDrawerHeader);

    var openMegaHeader = document.querySelector('[data-tds-header][data-mega-open]');
    if (openMegaHeader) closeMega(openMegaHeader);

    var openDrawerPanelHeader = document.querySelector('[data-tds-header][data-drawer-panel-open]');
    if (openDrawerPanelHeader) closeDrawerAccordion(openDrawerPanelHeader);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var header =
      (event.target.matches && event.target.matches('[data-tds-header]') ? event.target : null) ||
      event.target.querySelector('[data-tds-header]');
    if (header) {
      bindHeader(header);
      return;
    }
    bootAll();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var header = event.target.querySelector('[data-tds-header]');
    if (header) unbindHeader(header);
  });
})();
